<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <a-form :wrapper-col="{ span: 24 }">
          <a-form-item v-for="(input, index) in EditableInputFields" :key="index" :wrapper-col="{ span: 6 }">
            <label>{{ input.label }}:</label>
            <a-input :id="input.input_id">
              <a-tooltip slot="suffix" :title="input.label">
                <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
              </a-tooltip>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" @click="add_to_db()">Add</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "CrudCreate",

  data() {
    return {
      columns: this.$route.params.data.columns,
      api_route: this.$route.params.data.api_route,
      EditableInputFields: [],
      EditableInputFieldsIDs: []
    };
  },
  mounted() {
    if (!this.$route.params.data || Object.keys(this.$route.params.data).length === 0 || !this.$route.params.data.columns || Object.keys(this.$route.params.data.columns).length === 0) {
      this.$router.push('/dashboards');
    }
  },
  created() {
    for (let key in this.columns) {
      let title = this.columns[key]['title'];
      if (title === 'Actions') {
        continue
      }
      let dataIndexValue = this.columns[key]['dataIndex'];
      if (dataIndexValue != 'id') {
        this.EditableInputFields.push(
          {
            label: title,
            input_id: dataIndexValue + '_id'
          }
        );
        this.EditableInputFieldsIDs.push(
          dataIndexValue + '_id'
        );
      }
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();

    },
    //     async update_db() {
    //   try {
    //     const requestData = {};
    //     for (const key of this.EditableInputFieldsIDs) {
    //       const id_key = key.replace("_id", "");
    //       const input_value = this.EditableInputFields.find(
    //         input => input.input_id === key
    //       ).value;
    //       requestData[id_key] = input_value;
    //     }

    //     const response = await axios.post("ek weeni ", requestData);
    //     console.log(response.data); 


    //     this.EditableInputFields.forEach(input => {
    //       input.value = "";
    //     });
    //   } catch (error) {
    //     console.error("Error sending data:", error);
    //   }
    // }
    add_to_db() {
      this.arr_val = [{}];
      for (var key in this.EditableInputFieldsIDs) {
        var id = this.EditableInputFieldsIDs[key];
        var id_key = id.replace('_id', '');
        var input_value = document.getElementById(id.toString()).valueOf().value;

        this.arr_val[0][id_key] = input_value;
      }
      // var request_json = JSON.stringify(this.arr_val);
      console.log(this.arr_val);

      this.$store.dispatch(this.api_route, this.arr_val[0]);
    }
  }

};
</script>
  
<style scoped>
/* Your styles */
</style>
  